// BUSA-2717 Enable customers to select multiple items for deletion on cart page
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";

import { SearchState } from "./SearchState";
import { CustomSuggestionQueryModel } from "@BrasselerDental/Types/SuggestionModel";


const initialSearchState: SearchState = {
    searchResult: {} as CustomSuggestionQueryModel,
};

const reducer = {
    "Custom/Search/SetSearchResult": (
        draft: Draft<SearchState>,
        action: { searchResult: CustomSuggestionQueryModel },
    ) => {
        draft.searchResult = action.searchResult;
    },
};

export default createTypedReducerWithImmer(initialSearchState, reducer);
